/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../icon/icon';

const Counter = ({ currentSlide, hasIcon, itemsShowing, hasCounterDots, onSlideNumberChange }) => {
    return (
        <>
            {hasCounterDots ? (
                <div className="counter-dots-container">
                    {itemsShowing > 1 &&
                        [...Array(itemsShowing)].map((e, idx) => {
                            const isCurrentSlide = classNames('circle-counter', {
                                'is-current-slide': currentSlide === idx + 1,
                            });

                            return (
                                <button
                                    type="button"
                                    key={e}
                                    onClick={() => onSlideNumberChange(idx + 1)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            onSlideNumberChange(idx + 1);
                                        }
                                    }}
                                    className={isCurrentSlide}
                                />
                            );
                        })}
                </div>
            ) : (
                <div className="carousel-counter-container">
                    {hasIcon && (
                        <span className="carousel-counter-icon">
                            <Icon type="camera" />
                        </span>
                    )}
                    <p className="carousel-counter" data-q="carousel-counter">
                        {currentSlide} of {itemsShowing}
                    </p>
                </div>
            )}
        </>
    );
};

Counter.propTypes = {
    currentSlide: PropTypes.number.isRequired,
    hasCounterDots: PropTypes.bool,
    hasIcon: PropTypes.bool,
    itemsShowing: PropTypes.number.isRequired,
    onSlideNumberChange: PropTypes.func.isRequired,
};

Counter.defaultProps = {
    hasCounterDots: false,
    hasIcon: false,
};

export default Counter;
